import { Icons, useHelmet } from '@agro-club/agroclub-shared'
import { useFilters } from 'hooks/useFilter'
import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import * as Layout from 'views/layouts/NewLayout'
import * as Header from 'views/ui/Header/Header'
import { AddUser } from './ModalUser/AddUser'
import { useColumns } from './useColumns'
import { UserFilters } from './UserFilters/UserFilters'

import { isUS } from 'env'
import { AuthContext } from 'modules/context/AuthContext'
import { ProfileType } from 'modules/domain/user/types'
import { AButton } from 'views/components/Analytics'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import { AnalyticsPages, AnalyticsPlaces } from './analyticsPlaces'

const UserList: FC = () => {
  const { t } = useTranslation(['user'])
  useHelmet({ title: t('usersMetaTitle') })
  const { profile: currentUser } = useContext(AuthContext)
  const [visibilityModal, setVisibilityModal] = useState(false)

  const [listRequestParams, setListRequestParams] = useState<ListRequestParams>({
    ...defaultListRequestParams,
  })
  let defaultParams: Record<string, unknown> = {
    team: currentUser?.profile?.team?.id && String(currentUser?.profile?.team?.id),
  }
  if (isUS) {
    defaultParams = { ...defaultParams, profile_type: ProfileType.seller, is_active: 'true' }
  }
  const { isFiltersLoaded, updateFilterState } = useFilters({
    listRequestParams,
    setListRequestParams,
    defaultParams,
  })
  const columns = useColumns()

  return (
    <APageWrapper page={AnalyticsPages.USERS} place={AnalyticsPlaces.LIST}>
      <Layout.WrapperContent>
        <Layout.Header>
          <Layout.TopHeader>
            <Header.Breadcrumbs routes={[{ breadcrumbName: t('list.heading') }]} />
            <AButton
              id="add"
              Icon={Icons.IconAdd}
              color="approve"
              size="medium"
              onClick={() => setVisibilityModal(true)}
            >
              {t('common:add')}
            </AButton>
          </Layout.TopHeader>
          <Layout.PageName>{t('list.heading')}</Layout.PageName>
          <UserFilters
            setListRequestParams={setListRequestParams}
            updateFilterState={updateFilterState}
            listRequestParams={listRequestParams}
            isFiltersLoaded={isFiltersLoaded}
          />
        </Layout.Header>

        <ATableFullPage
          listParamsUpdated={setListRequestParams}
          listRequestParams={listRequestParams}
          isFiltersLoaded={isFiltersLoaded}
          dataEndpoint={endpoints.users()}
          columns={columns}
          rowHoverGray
        />

        {visibilityModal && (
          <AddUser
            onSuccess={() => setListRequestParams((prev) => ({ ...prev }))}
            onClose={() => setVisibilityModal(false)}
          />
        )}
      </Layout.WrapperContent>
    </APageWrapper>
  )
}

export default UserList
